window.countries = {
    AD: "Andorra (EUR €)",
    AR: "Argentina (EUR €)",
    AT: "Austria (EUR €)",
    AU: "Australia (EUR €)",
    BE: "Belgium (EUR €)",
    BG: "Bulgaria (EUR €)",
    BY: "Belarus (EUR €)",
    CA: "Canada (CAD $)",
    CH: "Switzerland (EUR €)",
    CL: "Chile (EUR €)",
    CN: "China (EUR €)",
    CZ: "Czech republic (EUR €)",
    DE: "Germany (EUR €)",
    DK: "Denmark (EUR €)",
    EE: "Estonia (EUR €)",
    ES: "Spain (EUR €)",
    FI: "Finland (EUR €)",
    FR: "France (EUR €)",
    GB: "United Kingdom (GBP £)",
    GI: "Gibraltar (EUR €)",
    GR: "Greece (EUR €)",
    HK: "Hong Kong (China) (EUR €)",
    HR: "Croacia (EUR €)",
    HU: "Hungary (EUR €)",
    IE: "Ireland (EUR €)",
    IS: "Island (EUR €)",
    IT: "Italy (EUR €)",
    JP: "Japan (EUR €)",
    KR: "South Korea (EUR €)",
    LI: "Liechtenstein (EUR €)",
    LT: "Lithuania (EUR €)",
    LU: "Luxembourg (EUR €)",
    LV: "Latvia (EUR €)",
    MC: "Monaco (EUR €)",
    MD: "Moldova (EUR €)",
    ME: "Montenegro (EUR €)",
    MK: "North Macedonia (EUR €)",
    MX: "Mexico (EUR €)",
    NL: "Netherlands (EUR €)",
    NO: "Norway (EUR €)",
    PL: "Poland (EUR €)",
    PT: "Portugal (EUR €)",
    RO: "Romania (EUR €)",
    RS: "Serbia (EUR €)",
    SE: "Sweden (EUR €)",
    SG: "Singapore (EUR €)",
    SI: "Slovenia (EUR €)",
    SK: "Slovakia (EUR €)",
    SM: "San Marino (EUR €)",
    US: "United States (USD $)",
};
